const goals = [
  'Foster consensus around the true state of Australia\'s methane emissions',
  'Establish a national framework & commitment to reduce methane',
  'Limit and mitigate methane emissions',
  'Provide analysis and information to inform policy choices that accelerate Australia\'s zero carbon transformation',
];

export default goals;
